import { render, staticRenderFns } from "./CollegeStudentManage.vue?vue&type=template&id=6a265a0f&scoped=true"
import script from "./CollegeStudentManage.vue?vue&type=script&lang=js"
export * from "./CollegeStudentManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a265a0f",
  null
  
)

export default component.exports